// The one client-side reading of `video.captureGapFrames`.
//
// A capture gap is a stretch where the camera was OFF (overnight, a weekend),
// and the field records the FIRST frame AFTER each one. Three separate client
// features consume it — the render-side segment splitter (lib/editDraft.js),
// the trim chart's gap markers (utils/motionTimeline.js) and the pace chart's
// motion mask (lib/motionPace.js) — and they must agree on WHICH frames count,
// or the picture on screen describes a different cut than the render makes.
//
// It lives in its own module because `lib/editDraft.js` already imports
// `lib/motionPace.js`; leaving the coercion in editDraft would make the pace
// chart's use of it a circular import between the two.

/**
 * `captureGapFrames`, coerced the way the render worker coerces it.
 *
 * The field is client-writable in Firestore like every project field, so
 * anything that is not a whole number is dropped, and the rest deduplicated and
 * sorted ascending. Booleans are excluded for free — `typeof true !== 'number'`.
 */
export const normalizeGapFrames = (gapFrames) => {
  if (!Array.isArray(gapFrames)) return [];
  const frames = new Set();
  for (const raw of gapFrames) {
    if (typeof raw === 'number' && Number.isInteger(raw)) frames.add(raw);
  }
  return [...frames].sort((a, b) => a - b);
};
